import "@fortawesome/fontawesome-free/css/all.min.css";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import { ConsultForm } from "./pages/consultForm";
import { ConsultLiff } from "./pages/consultLiff";
import Article from "pages/article";
import Consulting from "pages/consulting";
import InfoList from "pages/infoList";
import ClinicList from "pages/clinicList";
import Profile from "pages/profile";
import SetClinic from './pages/setClinic';
import RegClinic from './pages/regClinic';
import NoteList from './pages/noteList';
import NoteAdd from './pages/noteAdd';
import NoteEdit from './pages/noteEdit';
import ContentPage from './pages/contentPage';
import Invite from 'pages/invite';
import LineJoin from './pages/lineJoin';
import VideoConsultant from './pages/videoConsultant';
import VideoJoin from './pages/videoJoin';
import SourceWelcome from './pages/sourceWelcome';
import Activity from './pages/activity';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/clinicList" element={<ClinicList />} />
      <Route path="/consultForm" element={<ConsultForm />} />
      <Route path="/consultLiff110" element={<ConsultLiff />} />
      <Route path="/consulting" element={<Consulting />} />
      <Route path="/infoList" element={<InfoList />} />
      <Route path="/infoList/:articleId" element={<Article />} />
      <Route path="/noteList/:token" element={<NoteList />} />
      <Route path="/noteAdd/:token" element={<NoteAdd />} />
      <Route path="/noteEdit/:token/:noteUuid" element={<NoteEdit />} />
      <Route path="/contents/:uuid" element={<ContentPage />} />
      <Route path="/profile" element={<Profile/>} />
      <Route path="/invite" element={<Invite />} />
      <Route path="/invite/line-join/:uuid" element={<LineJoin />} />
      <Route path="/setClinic" element={<SetClinic />} />
      <Route path="/regClinic" element={<RegClinic />} />
      <Route path="/videoConsultant/:hostUuid" element={<VideoConsultant />} />
      <Route path="/videoJoin/:meetingUuid" element={<VideoJoin />} />
      <Route path="/source" element={<SourceWelcome />} />
      <Route path="/source/:keyword" element={<SourceWelcome />} />
      <Route path="/activity" element={<Activity />} />
    </>
  )
);